<div class="d-flex align-items-center justify-content-between pb-2">
  <a class="btn-floating btn-sm btn-light z-depth-0 m-0" (click)="onPrevious()"><i class="fas fa-arrow-alt-left blue-grey-text"></i></a>
  <div class="text-center animated fadeInDown text-elegant">{{ title | translate }}</div>
  <a class="btn-floating btn-sm btn-light z-depth-0 m-0" (click)="onNext()"><i class="fas fa-arrow-alt-right blue-grey-text"></i></a>
</div>